import React, { Component } from 'react'
import Location from '../../enums/Location'
import Sidenote from './Sidenote'
import {
  getStudyPeriodCalendarTypes,
  getAttributeCourseStaticInfo
} from '../../helpers/enrolment'
import ResidencyType from '../../enums/ResidencyType'

class UnitSelectionInstructions extends Component {
  getStudyLoadWarning = () => {
    if (this.props.loading) {
      return null
    }
    return ResidencyType.International.includes(this.props.citizenshipCode) &&
      getAttributeCourseStaticInfo('isOffshoreFlag') === 'N' ? (
      <div>
        <p>
          <strong>Important:</strong>
          As part of your visa requirements, you must complete your course with
          in the expected course duration as per your Confirmation of Enrolment
          (COE). To meet this requirement, you are encouraged to enrol in to
          full-time study load i.e. 48 Credit Points per semester. If you want
          to reduce your study load, you must apply for a
          <a
            href="https://www.vu.edu.au/sites/default/files/international/pdfs/FOR_Reduce-Study-For-Int-Students_A98_AU.pdf"
            target="_blank"
          >
            <strong>Reduced Study Load</strong>
          </a>{' '}
          form.
        </p>
      </div>
    ) : (
      <p>
        <strong>Full time students:</strong> To complete your course within the
        expected course duration you are encouraged to enrol in 48CP per
        semester.
        <br />
        <strong>Part time students:</strong> You have flexibility in the number
        of units you choose to study.
      </p>
    )
  }

  getPrefillText = () => {
    if (this.props.prefillAttemptSuccessful) {
      return this.getSuccessfulPrefillMessage()
    }
  }

  //added advance standing message
  getSuccessfulPrefillMessage = () => (
    <Sidenote>
      <div>
        <p>
          Your enrolment has been pre-filled with prescribed units to ensure you
          have met all of the requirements of your course and pattern of study.
          <br />
          Amendments to unit offerings can only be made after you have submitted
          your enrolment.
          <br />
          If you have any questions please contact{' '}
          <a
            href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres"
            target="_blank"
          >
            <strong>VUHQ</strong>
          </a>{' '}
        </p>
        {this.props.unspecifiedAdvanceStandingFlag === 'Y' && (
          <p>
            <strong>Note:</strong> You have Unspecified Advanced Standing credit
            towards your degree. Please ensure you check which units you are
            required to complete before finalising your enrolment.
          </p>
        )}
      </div>
    </Sidenote>
  )

  getUnableToEnrolInMoreStudyPeriods = () => {
    return false
    //TODO need to see if this needs any checks
    //    const studyPeriodAddCohorts = this.props.addOrDropCohorts
    //      .map(({ cohortDtls }) => cohortDtls)
    //      .filter(({ calType, sProcessType }) => {
    //        if (sProcessType === 'ADD-UNIT') {
    //          return getStudyPeriodCalendarTypes().some(
    //            studyPeriodCalendarType => studyPeriodCalendarType === calType
    //          )
    //        }
    //        return false
    //      })
    //
    //    const allStudyPeriodsAvailable = getStudyPeriodCalendarTypes().every(
    //      studyPeriodCalendarType => {
    //        return studyPeriodAddCohorts.some(
    //          ({ calType }) => studyPeriodCalendarType === calType
    //        )
    //      }
    //    )
    //
    //    const enrolledStudyPeriodUnits = this.props.enrolledUnits.filter(
    //      ({ calendarType }) => {
    //        return getStudyPeriodCalendarTypes().some(
    //          studyPeriodCalendarType => studyPeriodCalendarType === calendarType
    //        )
    //      }
    //    )
    //
    //    const numberOfStudyPeriods = getStudyPeriodCalendarTypes().length
    //
    //    return (
    //      enrolledStudyPeriodUnits.length > 0 &&
    //      enrolledStudyPeriodUnits.length < numberOfStudyPeriods &&
    //      !allStudyPeriodsAvailable
    //    )
  }

  //TODO this message is more inclined towards the later intake should take into account other aspects
  renderBlockModelInstructions = () => {
    return (
      <div>
        <div className="mobile-margin">
          {this.getStudyLoadWarning()}
          {!this.props.loadingUnits && this.getPrefillText()}
        </div>
      </div>
    )
  }

  renderVUOnlineInstructions = () => {
    return (
      <div>
        <div className="mobile-margin">
          <p>
            Please review your enrolment below and remove or add units as
            needed.
          </p>
        </div>
        {this.getUnableToEnrolInMoreStudyPeriods() && (
          <Sidenote>
            <p>
              <strong>Note:</strong> You will need to enrol in your remaining
              unit/s when the next enrolment period opens.
            </p>
          </Sidenote>
        )}
      </div>
    )
  }

  render() {
    if (this.props.blockStatus) {
      return this.renderBlockModelInstructions()
    }

    if (this.props.defaultLocation === Location.ZV) {
      return this.renderVUOnlineInstructions()
    }
    return (
      !this.props.loading &&
      !this.props.prefillAttemptSuccessful && (
        <div>
          <div className="mobile-margin">
            <p className="page-intro">
              Find and add units to your enrolment here.
            </p>
            {this.getStudyLoadWarning()}
          </div>
        </div>
      )
    )
  }
}

export default UnitSelectionInstructions
